import React, { PropsWithChildren } from "react";
import "./LinkButton.css";
import { Link } from "@mui/material";

function LinkButton({ href, children }: PropsWithChildren<{ href: string }>) {
    return (
        <div className="covered-div">
            <Link className="cover-link" href={href}></Link>
            {children}
        </div>
    );
}

export default LinkButton;
